import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expert-ask',
  templateUrl: './expert-ask.component.html',
  styleUrls: ['./expert-ask.component.css']
})
export class ExpertAskComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
